import React, { useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Button, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { getAllUsers } from "../../../../redux/features/foodSlice";
import { verifyPayment } from "../../../../redux/features/trasportationSlice";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";

const VerifyPayment = ({ params, bulk, setSelectedIds }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { loading } = useSelector((state) => state.transportation);
  const { enqueueSnackbar } = useSnackbar();
  const handleSubmit = () => {
    dispatch(verifyPayment(bulk ? params : [params.row.userID])).then((res) => {
      if (res.payload.status === "failed") {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      } else if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        dispatch(getAllUsers());
        setOpen(false);
        if (bulk) {
          setSelectedIds([]);
        }
      }
    });
  };
  return (
    <GlobalDialog
      title={"Verify Payment"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      popupButton={
        <Button
          variant="outlined"
          sx={{ borderRadius: 4 }}
          size="small"
          onClick={() => setOpen(true)}
        >
          <Icon
            icon="material-symbols:verified-outline-rounded"
            width="18"
            height="18"
          />
          {bulk ? "Verify Checked" : "Verify"}
        </Button>
      }
      content={
        <Box>
          {open ? (
            <Box>
              <Typography>
                Are you sure..? you want to verify this payment..?
              </Typography>
            </Box>
          ) : null}
        </Box>
      }
      actionButton={
        open && (
          <Button
            size="small"
            variant="outlined"
            disabled={loading}
            sx={{ borderRadius: 4 }}
            onClick={handleSubmit}
          >
            <Icon
              icon="material-symbols:verified-outline-rounded"
              width="18"
              height="18"
            />
            {loading ? "Please Wait..." : "Verify"}
          </Button>
        )
      }
    />
  );
};

export default VerifyPayment;
